<template>
  <b-container>
    <b-modal id="modal-prevent-closing" ref="script" title="Script" size="xl">
      <div>
        <!-- {{stage.scriptPython}} -->
        <b-form-group
          label="Script pós processamento"
          label-for="ScriptPythonValidation"
        >
          <custom-codemirror
            id="ScriptPythonValidation"
            :model.sync="stage.scriptPython"
            :readonly="true"
          />
        </b-form-group>
      </div>
      <div>
        <!-- {{stage.validationScript}} -->
        <b-form-group
          label="Script de validação"
          label-for="ScriptPythonValidation"
        >
          <custom-codemirror
            id="ScriptPythonValidation"
            :model.sync="stage.validationScript"
            :readonly="true"
          />
        </b-form-group>
      </div>

      <div>
        <b-form-group
          label="Script de serviço"
          label-for="backgroundServiceScript"
        >
          <custom-codemirror
            id="backgroundServiceScript"
            :model.sync="stage.backgroundServiceScript"
            :readonly="true"
          />
        </b-form-group>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <div class="right">
          <b-button class="ml-2" variant="green" @click="ok()">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
import CustomCodemirror from "@/components_rms/checklist/form/CustomCodemirror.vue";

export default {
  name: "StageScriptModal",
  props: {},
  components: {
    CustomCodemirror
  },
  created() {},
  data() {
    return {
      stage: []
    };
  },
  methods: {
    show(item) {
      console.log(item);
      this.stage = item;
      this.$refs.script.show();
    }
  }
};
</script>
